import { Box } from "@mui/material";
import { assetUrl } from "../../utils";

type LoaderProps = {
  size?: string | number;
  white?: boolean;
};

export const Loader = ({ size, white }: LoaderProps) => (
  <Box
    component="img"
    src={
      white
        ? assetUrl("images/loading-circle-white.png")
        : assetUrl("images/loading-circle.png")
    }
    alt="loading"
    sx={{
      animation: "spin 1.5s linear infinite",
      "@keyframes spin": {
        "0%": {
          transform: "rotate(360deg)",
        },
        "100%": {
          transform: "rotate(0deg)",
        },
      },
      width: size,
      height: size,
    }}
  />
);
